import SharedSortableLists from './SharedSortableLists'
import ContentAdsList from './ContentAdsList'

export default class AdContentSorting extends SharedSortableLists {
  reactTableComponent() {
    return ContentAdsList;
  }

  defaultSortKey() {
    return "size"
  }

  sortData() {
    switch(this.sortKey) {
      case "name":
        return this.sortMulti([
          { attr: "clientName" },
          { attr: "rawSize", reverseNever: true },
        ])
        break;
      case "status":
        return this.sortMulti([
          { attr: "status", reverse: true },
          { attr: "clientName", reverseNever: true },
        ])
        break;
      case "date":
        return this.sortMulti([
          { attr: "modifiedAt" },
          { attr: "clientName", reverseNever: true },
        ])
        break;
      case "placement":
        return this.sortMulti([
          { attr: "sortableLocation" },
          { attr: "rawSize" },
          { attr: "clientName", reverseNever: true },
        ])
        break;
      case "size":
        return this.sortMulti([
          { attr: "rawSize", reverse: true },
          { attr: "clientName", reverseNever: true },
        ])
        break;
    }
  }
}
